/**
 * Slot Check Search → casino hand-off, Explore side.
 *
 * Applies the tapped game exactly like picking that game in the casino's own
 * Slot Search (components/Search onSelectGroup): search mode on, bank filter
 * off, chip = game name, SelectedSlots = that casino's matching EGMs, compare
 * selection cleared. An EGM tap also opens that EGM's Details (same as a
 * Search row tap: addToSlotHistory(detail id)).
 */
import type { UniversalSearchEntryIntent } from './universalSearchSession';

export type UniversalSearchFilterCommands = {
  setSearchMode: (on: boolean) => void;
  selectBankFilter: (on: boolean) => void;
  setSelectedSlotsName: (name: string) => void;
  setSelectedSlots: (ids: string[]) => void;
  clearCompareSelection: () => void;
  openDetail: (id: number) => void;
};

/** Detail ids as Search uses them: numeric (mnum / slot_number), deduped. */
export function toSearchSlotIds(ids: unknown[]): string[] {
  const out: string[] = [];
  const seen = new Set<string>();
  for (const raw of ids || []) {
    const n = Number(String(raw ?? '').trim());
    if (!Number.isFinite(n) || String(raw ?? '').trim() === '') continue;
    const k = String(n);
    if (seen.has(k)) continue;
    seen.add(k);
    out.push(k);
  }
  return out;
}

export function applyUniversalSearchFilter(
  intent: Pick<UniversalSearchEntryIntent, 'filterName' | 'detailIds' | 'openDetailId'>,
  cmd: UniversalSearchFilterCommands
): { applied: boolean; slotIds: string[]; openedDetail: number | null } {
  const slotIds = toSearchSlotIds(intent.detailIds);
  if (!slotIds.length) return { applied: false, slotIds, openedDetail: null };
  cmd.setSearchMode(true);
  cmd.selectBankFilter(false);
  cmd.setSelectedSlotsName(intent.filterName);
  cmd.setSelectedSlots(slotIds);
  cmd.clearCompareSelection();
  let openedDetail: number | null = null;
  if (intent.openDetailId !== null && intent.openDetailId !== undefined && intent.openDetailId !== '') {
    const n = Number(intent.openDetailId);
    if (Number.isFinite(n)) {
      cmd.openDetail(n);
      openedDetail = n;
    }
  }
  return { applied: true, slotIds, openedDetail };
}
